import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatareweofferingRoutingModule } from './whatareweoffering-routing.module';
import { WhatareweofferingComponent } from './whatareweoffering.component';
import { MaterialDesignModule } from '../material-design/material-design.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [WhatareweofferingComponent],
  imports: [
    CommonModule,
    WhatareweofferingRoutingModule,
    MaterialDesignModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SharedModule,
  ],
  exports:[
    WhatareweofferingComponent
  ]
})
export class WhatareweofferingModule { }
